const state = {
  errorMessage: {
    required: false,
    endpoints: [],
    messages: []
  }
};

export default state;
